export { default } from 'wfui-digital-core/es/Block';